import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import API from '../services/api';

const ESTADOS = {
  activo: { label: 'Activo', bg: '#EAF3DE', color: '#3B6D11' },
  pausado: { label: 'Pausado', bg: '#F5EFD6', color: '#8B6914' },
  cerrado: { label: 'Cerrado', bg: '#f0f0ed', color: '#888' },
};


function HistorialCambios({ log, styles: s }) {
  const [abierto, setAbierto] = useState(false);
  return (
    <div style={s.card}>
      <div style={{...s.cardHeaderRow || s.cardTitle, display:'flex', alignItems:'center', justifyContent:'space-between', cursor:'pointer', marginBottom: abierto ? 16 : 0}} onClick={() => setAbierto(!abierto)}>
        <div style={s.cardTitle} >Historial de cambios {log.length > 0 && <span style={{fontSize:11, color:'#aaa', fontWeight:400}}>({log.length})</span>}</div>
        <span style={{fontSize:12, color:'#aaa'}}>{abierto ? '▲ Ocultar' : '▼ Mostrar'}</span>
      </div>
      {abierto && (
        log.length === 0 ? (
          <div style={s.emptySmall}>Sin cambios registrados</div>
        ) : (
          log.map((entry, i) => (
            <div key={i} style={{display:'flex',alignItems:'baseline',gap:12,padding:'10px 0',borderBottom:'0.5px solid #f0f0ed',fontSize:12}}>
              <span style={{color:'#aaa',flexShrink:0,fontFamily:'monospace',fontSize:11,minWidth:120}}>{new Date(entry.fecha).toLocaleString('es-ES',{day:'2-digit',month:'2-digit',year:'numeric',hour:'2-digit',minute:'2-digit'})}</span>
              <span style={{color:'#378ADD',flexShrink:0,fontWeight:500}}>{entry.usuario}</span>
              <span style={{color:'#666'}}>{entry.texto}</span>
            </div>
          ))
        )
      )}
    </div>
  );
}

export default function ClienteDetalle() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { usuario } = useAuth();
  const [cliente, setCliente] = useState(null);
  const [proyectos, setProyectos] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [log, setLog] = useState([]);
  const [modalEditar, setModalEditar] = useState(false);
  const [form, setForm] = useState({});
  const [error, setError] = useState('');

  useEffect(() => { cargar(); }, [id]);

  const cargar = async () => {
    try {
      const [cRes, pRes, lRes] = await Promise.all([
        API.get('/clientes'),
        API.get('/proyectos'),
        API.get(`/log?entidad=cliente&entidad_id=${id}`),
      ]);
      setLog(lRes?.data || []);
      const c = cRes.data.find(x => x.id === parseInt(id));
      setCliente(c || null);
      setProyectos(pRes.data.filter(p => p.cliente === c?.nombre));
    } catch(e) {}
    setCargando(false);
  };

  const guardarEditar = async () => {
    if (!form.nombre?.trim()) { setError('El nombre es obligatorio'); return; }
    try {
      await API.put(`/clientes/${id}`, {
        nombre: form.nombre,
        email: form.email || null,
        telefono: form.telefono || null,
        direccion: form.direccion || null,
        cif: form.cif || null,
        contacto: form.contacto || null,
        notas: form.notas || null,
      });
      setModalEditar(false);
      cargar();
    } catch(e) { setError('Error al guardar'); }
  };

  const eliminar = async () => {
    if (!window.confirm(`¿Eliminar a ${cliente.nombre}?`)) return;
    await API.delete(`/clientes/${id}`);
    navigate('/clientes');
  };

  const fmtFecha = (iso) => iso ? new Date(iso).toLocaleDateString('es-ES', {day:'2-digit',month:'2-digit',year:'numeric'}) : '—';

  if (cargando) return <div style={s.loading}>Cargando...</div>;
  if (!cliente) return <div style={s.loading}>Cliente no encontrado</div>;

  return (
    <div style={s.page}>
      <div style={s.topbar}>
        <button style={s.backBtn} onClick={() => navigate('/clientes')}>← Clientes</button>
      </div>

      <div style={s.content}>
        <div style={s.header}>
          <div>
            <div style={s.headerNombre}>{cliente.nombre}</div>
            {cliente.contacto && <div style={s.headerSub}>{cliente.contacto}</div>}
          </div>
          {usuario?.rol === 'admin' && (
            <div style={s.headerActions}>
              <button style={s.btnDanger} onClick={eliminar}>Eliminar</button>
              <button style={s.btn} onClick={() => navigate(`/clientes/${id}/editar`)}>Editar</button>
            </div>
          )}
        </div>

        <div style={s.grid2}>
          <div style={s.card}>
            <div style={s.cardTitle}>Datos de contacto</div>
            <div style={s.infoRow}><span style={s.infoLabel}>Email</span><span>{cliente.email || '—'}</span></div>
            <div style={s.infoRow}><span style={s.infoLabel}>Teléfono</span><span>{cliente.telefono || '—'}</span></div>
            <div style={s.infoRow}><span style={s.infoLabel}>CIF</span><span>{cliente.cif || '—'}</span></div>
            <div style={s.infoRow}><span style={s.infoLabel}>Dirección</span><span>{cliente.direccion || '—'}</span></div>
            {cliente.notas && <div style={{...s.infoRow, flexDirection:'column', gap:4}}><span style={s.infoLabel}>Notas</span><span style={{fontSize:13}}>{cliente.notas}</span></div>}
          </div>

          <div style={s.card}>
            <div style={s.cardTitle}>Resumen</div>
            <div style={s.infoRow}><span style={s.infoLabel}>Proyectos totales</span><span style={{fontWeight:600}}>{proyectos.length}</span></div>
            <div style={s.infoRow}><span style={s.infoLabel}>Proyectos activos</span><span style={{color:'#3B6D11', fontWeight:600}}>{proyectos.filter(p=>p.estado==='activo').length}</span></div>
            <div style={s.infoRow}><span style={s.infoLabel}>Proyectos cerrados</span><span style={{color:'#888'}}>{proyectos.filter(p=>p.estado==='cerrado').length}</span></div>
            <div style={s.infoRow}>
              <span style={s.infoLabel}>Presupuesto total</span>
              <span style={{fontWeight:600, color:'#378ADD'}}>
                {proyectos.reduce((a,p) => a + (parseFloat(p.presupuesto)||0), 0).toLocaleString('es-ES')}€
              </span>
            </div>
          </div>
        </div>

        <div style={s.card}>
          <div style={s.cardHeaderRow}>
            <div style={s.cardTitle}>Proyectos</div>
            {usuario?.rol === 'admin' && (
              <button style={s.btnSmall} onClick={() => navigate(`/proyectos/nuevo?cliente=${encodeURIComponent(cliente.nombre)}`)}>+ Nuevo proyecto</button>
            )}
          </div>
          {proyectos.length === 0 ? (
            <div style={s.emptySmall}>Sin proyectos asociados</div>
          ) : (
            proyectos.map(p => (
              <div key={p.id} style={s.proyectoRow} onClick={() => navigate(`/proyectos/${p.id}`)}>
                <div>
                  <div style={s.proyectoNombre}>{p.nombre}</div>
                  <div style={s.proyectoFecha}>{fmtFecha(p.fecha_inicio)} → {fmtFecha(p.fecha_fin)}</div>
                </div>
                <div style={s.proyectoRight}>
                  {p.presupuesto && <span style={s.proyectoPres}>{parseFloat(p.presupuesto).toLocaleString('es-ES')}€</span>}
                  <span style={{...s.pill, background: ESTADOS[p.estado]?.bg, color: ESTADOS[p.estado]?.color}}>
                    {ESTADOS[p.estado]?.label}
                  </span>
                </div>
              </div>
            ))
          )}
        </div>
      <HistorialCambios log={log} styles={s} />
      </div>

      {modalEditar && (
        <div style={s.overlay} onClick={() => setModalEditar(false)}>
          <div style={s.modal} onClick={e => e.stopPropagation()}>
            <div style={s.modalHeader}><div style={s.modalTitle}>Editar cliente</div><button style={s.closeBtn} onClick={() => setModalEditar(false)}>✕</button></div>
            {error && <div style={s.errorBox}>{error}</div>}
            <div style={s.field}><label style={s.label}>Nombre *</label><input style={s.input} value={form.nombre||''} onChange={e => setForm({...form, nombre: e.target.value})} /></div>
            <div style={s.field}><label style={s.label}>Persona de contacto</label><input style={s.input} value={form.contacto||''} onChange={e => setForm({...form, contacto: e.target.value})} /></div>
            <div style={s.fieldRow}>
              <div style={{...s.field, flex:1}}><label style={s.label}>Email</label><input style={s.input} value={form.email||''} onChange={e => setForm({...form, email: e.target.value})} /></div>
              <div style={{...s.field, flex:1}}><label style={s.label}>Teléfono</label><input style={s.input} value={form.telefono||''} onChange={e => setForm({...form, telefono: e.target.value})} /></div>
            </div>
            <div style={s.fieldRow}>
              <div style={{...s.field, flex:1}}><label style={s.label}>CIF</label><input style={s.input} value={form.cif||''} onChange={e => setForm({...form, cif: e.target.value})} /></div>
              <div style={{...s.field, flex:1}}><label style={s.label}>Dirección</label><input style={s.input} value={form.direccion||''} onChange={e => setForm({...form, direccion: e.target.value})} /></div>
            </div>
            <div style={s.field}><label style={s.label}>Notas</label><textarea style={{...s.input, height:72, resize:'vertical'}} value={form.notas||''} onChange={e => setForm({...form, notas: e.target.value})} /></div>
            <div style={s.modalFooter}>
              <button style={s.btnSecondary} onClick={() => setModalEditar(false)}>Cancelar</button>
              <button style={s.btn} onClick={guardarEditar}>Guardar cambios</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

const s = {
  page: { display:'flex', flexDirection:'column', minHeight:'100vh', background:'#f5f5f3', fontFamily:'-apple-system, BlinkMacSystemFont, Inter, sans-serif' },
  loading: { display:'flex', alignItems:'center', justifyContent:'center', height:'100vh', color:'#aaa', fontSize:14 },
  topbar: { background:'white', borderBottom:'0.5px solid #e0e0d8', padding:'0 24px', height:48, display:'flex', alignItems:'center' },
  backBtn: { background:'none', border:'none', fontSize:13, color:'#378ADD', cursor:'pointer', fontWeight:500 },
  content: { padding:24, display:'flex', flexDirection:'column', gap:16 },
  header: { background:'white', border:'0.5px solid #e0e0d8', borderRadius:12, padding:24, display:'flex', alignItems:'center', justifyContent:'space-between', flexWrap:'wrap', gap:16 },
  headerNombre: { fontSize:20, fontWeight:600, color:'#1a1a1a', marginBottom:4 },
  headerSub: { fontSize:13, color:'#888' },
  headerActions: { display:'flex', gap:8 },
  grid2: { display:'grid', gridTemplateColumns:'1fr 1fr', gap:16 },
  card: { background:'white', border:'0.5px solid #e0e0d8', borderRadius:12, padding:20 },
  cardTitle: { fontSize:13, fontWeight:600, color:'#1a1a1a', marginBottom:16 },
  cardHeaderRow: { display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:16 },
  infoRow: { display:'flex', justifyContent:'space-between', padding:'8px 0', borderBottom:'0.5px solid #f0f0ed', fontSize:13, color:'#1a1a1a' },
  infoLabel: { color:'#888' },
  proyectoRow: { display:'flex', alignItems:'center', justifyContent:'space-between', padding:'12px 0', borderBottom:'0.5px solid #f0f0ed', cursor:'pointer' },
  proyectoNombre: { fontSize:13, fontWeight:500, color:'#1a1a1a', marginBottom:2 },
  proyectoFecha: { fontSize:11, color:'#aaa' },
  proyectoRight: { display:'flex', alignItems:'center', gap:8 },
  proyectoPres: { fontSize:13, fontWeight:600, color:'#378ADD' },
  pill: { fontSize:11, padding:'2px 8px', borderRadius:10, fontWeight:500 },
  emptySmall: { fontSize:13, color:'#aaa', padding:'16px 0', textAlign:'center' },
  btn: { background:'#378ADD', color:'white', border:'none', borderRadius:8, padding:'8px 14px', fontSize:13, fontWeight:500, cursor:'pointer' },
  btnSmall: { background:'#378ADD', color:'white', border:'none', borderRadius:6, padding:'5px 10px', fontSize:12, cursor:'pointer' },
  btnSecondary: { background:'white', color:'#666', border:'0.5px solid #d0d0c8', borderRadius:8, padding:'8px 14px', fontSize:13, cursor:'pointer' },
  btnDanger: { background:'#FCEBEB', color:'#A32D2D', border:'none', borderRadius:8, padding:'8px 14px', fontSize:13, cursor:'pointer' },
  overlay: { position:'fixed', inset:0, background:'rgba(0,0,0,0.3)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:1000 },
  modal: { background:'white', borderRadius:12, border:'0.5px solid #e0e0d8', padding:24, width:'100%', maxWidth:480, maxHeight:'90vh', overflowY:'auto' },
  modalHeader: { display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:20 },
  modalTitle: { fontSize:15, fontWeight:500, color:'#1a1a1a' },
  closeBtn: { background:'none', border:'none', fontSize:16, cursor:'pointer', color:'#aaa' },
  errorBox: { background:'#FCEBEB', color:'#A32D2D', borderRadius:8, padding:'10px 14px', fontSize:13, marginBottom:16 },
  field: { marginBottom:16 },
  fieldRow: { display:'flex', gap:12 },
  label: { display:'block', fontSize:13, color:'#444', marginBottom:6, fontWeight:500 },
  input: { width:'100%', padding:'9px 12px', borderRadius:8, border:'0.5px solid #d0d0c8', fontSize:14, outline:'none', boxSizing:'border-box', background:'white' },
  logRow: { display:'flex', alignItems:'baseline', gap:12, padding:'10px 0', borderBottom:'0.5px solid #f0f0ed', fontSize:12 },
  logFecha: { color:'#aaa', flexShrink:0, fontFamily:'monospace', fontSize:11, minWidth:120 },
  logUsuario: { color:'#378ADD', flexShrink:0, fontWeight:500 },
  logAccion: { color:'#666' },
  modalFooter: { display:'flex', justifyContent:'flex-end', gap:10, marginTop:24 },
};
